// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quickstart-list[data-v-0cb9d4bd]{font-size:1rem}.quickstart-list li[data-v-0cb9d4bd]::marker{font-weight:600;color:var(--q-primary,#6366f1)}.quickstart-list li[data-v-0cb9d4bd]{padding-left:4px}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
